export default __webpack_public_path__ + "fbee174c8dc1c4da322fc63120c9d223.png";